import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import Uplaoder from './uploader.vue';
let default_1 = class default_1 extends Vue {
    previewInfos;
    position;
    uploadChange;
    disabled;
    form = {};
    uploadConfigs = [
        {
            prop: 'logo',
            title: 'Logo:',
            format: ['png'],
            size: 1024 * 1024,
            limit: 1,
            style: {
                width: '6rem',
                height: '6rem',
            },
        },
        {
            prop: 'screenCover',
            title: 'Screensaver:',
            format: ['png'],
            size: 1024 * 1024,
            limit: 1,
            resolution: '800 x 1280',
            style: {
                width: '6rem',
                height: '9.6rem',
            },
        },
    ];
    changeBase64Urls(data) {
        console.log('changeBase64Urls data', data);
        const { sourceData, base64Urls } = data;
        this.form[sourceData.prop] = base64Urls;
        this.uploadChange && this.uploadChange(this.form);
    }
};
__decorate([
    Prop()
], default_1.prototype, "previewInfos", void 0);
__decorate([
    Prop({ default: 'horizontal' })
], default_1.prototype, "position", void 0);
__decorate([
    Prop()
], default_1.prototype, "uploadChange", void 0);
__decorate([
    Prop()
], default_1.prototype, "disabled", void 0);
default_1 = __decorate([
    Component({
        name: 'passDeviceUploadBox',
        components: { Uplaoder },
    })
], default_1);
export default default_1;
